<div class='modal-header' [ngSwitch]='dialogMode' (click)='$event.stopPropagation()'>
  <ng-container *ngSwitchCase='"CREATE"'>
    <h4 class='modal-title'>
      {{'TITLE.NEW_COVID_ASSESSMENT' | translate}}
    </h4>
  </ng-container>

  <ng-container *ngSwitchCase='"DUPLICATE"'>
    <div class="d-flex flex-column">
      <h4 class='modal-title'>{{ "LABELS.DUPLICATE" | translate }}</h4>
      <span class="text-muted fst-italic small" *ngIf="duplicateCovidAssessmentPayload?.payload?.name">
        {{duplicateCovidAssessmentPayload?.payload?.name}}
      </span>
    </div>
  </ng-container>
</div>
<div class='modal-body' (click)='$event.stopPropagation()'>
  <ng-container *ngIf='formGroup && !loading'>
    <form [formGroup]='formGroup'>
      <div class='form-group' *ngIf='checkUsedField("name")'>
        <label class="form-label">{{'LABELS.NAME' | translate}} <span class='text-danger'>*</span></label>
        <input type='text'
               autocomplete='off'
               formControlName='name'
               [maxLength]='128'
               class='form-control form-control-sm'
        >
      </div>

      <div class='form-group' *ngIf='checkUsedField("description") && enabledTempate'>
        <label class="form-label">{{'LABELS.DESCRIPTION' | translate}}</label>
        <textarea
          autocomplete='off'
          formControlName='description'
          class='form-control form-control-sm'
          [rows]='5'
          aria-describedby='ptWInputHelp'>
          </textarea>
      </div>

      <div class='form-group' *ngIf='checkUsedField("internalId")'>
        <pt-input-text-conditional-checkbox
          [label]="'LABELS.INTERNAL_ID' | translate"
          [checkboxLabel]="'LABELS.DEFAULT_INTERNAL_ID' | translate"
          [cleanOnDisable]='true'
          [enableOnCheck]='false'
          [defaultCheckValue]='true'
          [controlName]="'internalId'"
          [activeValidatorsOnlyWhenEnabledInput]='true'
          formControlName='internalId'
          [validators]='[REQUIRED]'
        ></pt-input-text-conditional-checkbox>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf='loading'>
    <div class='loader-container'>
      <pt-loader></pt-loader>
    </div>
  </ng-container>
</div>

<div class='modal-footer' (click)='$event.stopPropagation()'>
  <button type='button' class='btn btn-primary btn-sm'
          [disabled]='formGroup?.invalid'
          (click)='confirm(); $event.stopPropagation()'>
    <ng-container [ngSwitch]='dialogMode'>
      <ng-container *ngSwitchCase='"CREATE"'>
        {{ 'BUTTON.CREATE' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase='"DUPLICATE"'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </ng-container>
    </ng-container>
  </button>
  <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
          (click)='activeModal.close(false); $event.stopPropagation()'>
    {{ 'BUTTON.CANCEL' | translate }}
  </button>
</div>
